import { redirect, useLoaderData, useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { Button } from '~/components/subscription/button'
import { TextLink } from '~/components/subscription/text-link'
import { formatDate, formatTime } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { styles } from './styles.css'
import box from './box.svg'

export const loader = async () => {
  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0]

  if (subscription) {
    const placements = await fetchPlacements(subscription.id)

    return [subscriptions, placements] as const
  } else {
    return redirect('/subscription/mypage')
  }
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'lossless_bouquet' })
}

function fetchPlacements(id) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdPlacements(id)
}

export const SubscriptionMypageSkip: React.FC = () => {
  const [
    {
      data: { data: subscriptions },
    },
    {
      data: { data: placements },
    },
  ] = useLoaderData<typeof loader>()
  const navigate = useNavigate()

  const subscription = subscriptions[0]
  const placement = placements[0]

  const handleClickSkip: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      await createClient(Subscriptions).postSubscriptionsSubscriptionIdPlacementsIdSkip(subscription.id, placement.id)
      await navigate('/subscription/mypage', { state: { message: '次回のお届けをスキップしました' } })
    } catch (error) {
      console.error(error)
    }
  }

  const handleClickUnskip: React.MouseEventHandler<HTMLAnchorElement> = async (e) => {
    e.preventDefault()

    try {
      await createClient(Subscriptions).postSubscriptionsSubscriptionIdPlacementsIdUnskip(subscription.id, placement.id)
      await navigate('/subscription/mypage', { state: { message: '次回のお届けのスキップを取り消しました' } })
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Flex direction="column" align="center" gap="32px">
      <PageHeading>スキップのお手続き</PageHeading>
      <Flex direction="column" align="center" gap="40px" width="100%">
        <Flex direction="column" align="start" className={styles.card}>
          <h3 className={styles.cardHeading}>次回の到着日</h3>
          <Flex direction="column" gap="2px">
            <p className={styles.date}>{formatDate(1000 * subscription.attributes.next_deliver_at, 'M/d（E）')}</p>
            <Flex direction="row" align="center" gap="4px" className={styles.note}>
              <img src={box} />
              クロネコヤマトで配送（対面でのお受け取り）
            </Flex>
          </Flex>
        </Flex>
        <Flex direction="column" align="center" gap="32px" width="100%">
          <Flex direction="column" align="center" gap="16px" width="100%">
            <p className={styles.warn}>{formatTime(1000 * subscription.attributes.skip_deadline)}まで変更が可能です</p>
            <Button as="button" size="m" fluid disabled={placement.attributes.status !== 'pending'} onClick={handleClickSkip}>
              次回のお届けをスキップ
            </Button>
            {placement.attributes.status === 'skipped' && (
              <a href="#" className={styles.skipLink} onClick={handleClickUnskip}>
                スキップを取り消す
              </a>
            )}
          </Flex>
          <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
        </Flex>
      </Flex>
    </Flex>
  )
}
